import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Grid, Typography, CircularProgress, Box, Breadcrumbs, Link } from '@mui/material';
import { collection, query, where, getDocs, orderBy } from 'firebase/firestore';
import { db } from '../firebase/config';
import ProductCard from '../components/ProductCard';
import { Link as RouterLink } from 'react-router-dom';

function CategoryProducts() {
  const { categoryId } = useParams();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Kategori ID'sini düzgün formata çevirme
  const normalizedCategoryId = categoryId.toLowerCase().replace(/%20/g, '-');

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        const q = query(
          collection(db, 'products'),
          where('category', '==', normalizedCategoryId),
          orderBy('createdAt', 'desc')
        );
        
        const querySnapshot = await getDocs(q);
        const productsData = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        
        setProducts(productsData);
      } catch (err) {
        console.error('Ürünler yüklenirken hata:', err);
        setError('Ürünler yüklenirken bir hata oluştu');
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [categoryId, normalizedCategoryId]);

  // Kategori adını düzgün formata çevirme
  const getCategoryName = (id) => {
    const names = {
      'ust-giyim': 'Üst Giyim',
      'alt-giyim': 'Alt Giyim',
      'dis-giyim': 'Dış Giyim',
      'elbiseler': 'Elbiseler'
    };
    return names[id.toLowerCase()] || id;
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Container sx={{ mt: { xs: '76px', sm: '84px' }, mb: 4 }}>
        <Typography color="error" align="center">{error}</Typography>
      </Container>
    );
  }

  return (
    <Container sx={{ mt: { xs: '76px', sm: '84px' }, mb: 4 }}>
      <Breadcrumbs sx={{ mb: 4 }}>
        <Link component={RouterLink} to="/" color="inherit">
          Ana Sayfa
        </Link>
        <Typography color="text.primary">{getCategoryName(normalizedCategoryId)}</Typography>
      </Breadcrumbs>

      <Typography variant="h4" component="h1" gutterBottom sx={{ mb: 4 }}>
        {getCategoryName(normalizedCategoryId)}
      </Typography>
      
      {products.length === 0 ? (
        <Typography align="center">Bu kategoride henüz ürün bulunmamaktadır.</Typography>
      ) : (
        <Grid container spacing={3}>
          {products.map((product) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={product.id}>
              <ProductCard product={product} />
            </Grid>
          ))}
        </Grid>
      )}
    </Container>
  );
}

export default CategoryProducts; 